import { createAction } from '@reduxjs/toolkit';
// step actions
export var setLoading = createAction('SET_LOADING');
export var setNextStep = createAction('SET_NEXT_STEP');
export var setPopupVisibility = createAction('SET_POPUP_VISIBILITY');
export var setTariffServicesData = createAction('SET_TARIFF_SERVICES_DATA');
export var resetTariffData = createAction('RESET_TARIFF_DATA');
// user data actions
export var setFlat = createAction('SET_FLAT');
export var setHouse = createAction('SET_HOUSE');
export var setStreet = createAction('SET_STREET');
export var resetUserData = createAction('RESET_USER_DATA');
export var setPhoneNumber = createAction('SET_PHONE_NUMBER');
export var setAddressViewValue = createAction('SET_ADDRESS_VIEW');
export var resetAddressData = createAction('RESET_ADDRESS_DATA');